import React from "react";
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import { bannerData } from "../Constants/data";
import {styled} from '@mui/material';
import { blue } from "@mui/material/colors";

 const Image = styled('img')({
    width: '90%',
    height: 480,
    border: "2px solide red"
 })

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

const Banner = ()=> {

    return (
         <Carousel 
          responsive={responsive}
          swipeable={false}
          draggable={false}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          keyBoardControl={true}
          slidesToSlide={1}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          containerClass="carousel-container"
         >
            {
                bannerData.map(data=>(
                    <Image src={data.url} alt="banner"/>
                ))
            }
         </Carousel>
    )
}
export default Banner;